import React from 'react';

import classes from './SakeItem.module.scss';

const SakeItem = (props) => {
    const appLayout = localStorage.getItem('app_layout') || 'ementas_digitais';

    const sakeBtnClasses = [classes.SakeItem, classes[props.tag], props.isSelected ? classes.selected : null].join(' ');
    
    return (
        <div className={classes[appLayout]}>
            <button className={sakeBtnClasses} onClick={props.onClick}>
                <span className={classes.title}>
                    {props.name}
                </span>
            </button>
        </div>
    )
}

export default SakeItem;